import { CategoryService } from '../services/CategoryService';

export function useCategoryService(): CategoryService {
  return new CategoryService(useApiClient(), useUserStore());
}
